// helper function to search for matching value/label
// instead of multiple switch functions
export const labelFor = (
  options: { label: string, value: string;}[],
  value?: string,
  emptyValue = "-",
) => {
  const match = options.find(({value: optVal}) => value === optVal);
  return (match !== undefined) ? match.label : emptyValue;
}

export const relationshipOptions = [
  { label: "Spouse", value: "spouse" },
  { label: "Parent", value: "parent" },
  { label: "Legal Guardian", value: "guardian" },
  { label: "Public Trustee", value: "trustee" },
  { label: "Power of Attorney", value: "attorney" },
]

export const typeOfBenefitOptions = [
  {
    label: "Ontario Works Program (OWP)",
    value: "owp",
  },
  {
    label: "Ontario Disability Support Program (ODSP)",
    value: "odsp",
  },
  {
    label: "Assistance to Children with Severe Disabilities (ACSD)",
    value: "acsd",
  },
];

export const benefitsOptions = [
  {
    label: "Yes",
    value: "y-benefits",
  },
  { label: "No", value: "n-benefits" },
];

export const coverageOptions = [
  {
    label: "Workspace Safety & Insurance Board (WSIB)",
    value: "wsib",
  },
  {
    label: "Veteran Affairs Canada (VAC) - Group A",
    value: "vac",
  },
];

export const customModificationsOptions = [
  {
    label: "Yes",
    value: "cm-yes",
  },
  {
    label: "No",
    value: "cm-no",
  },
];

export const reasonOptions = [
  {
    label: "First access for Mobility Devices",
    value: "first-access",
  },
  {
    label:
      "Another type of device required in addition to Previously ADP Funded Device(s)",
    value: "another-type",
  },
  {
    label: "Modifications to Non ADP Funded Device(s)",
    value: "modifications-non-adp",
  },
  {
    label: "Replacement of Previously ADP Funded Device(s) no longer in use",
    value: "replacement",
  },
  {
    label:
      "Modifications/Adjustments/Additional Components to Previously ADP Funded Device(s) currently in use",
    value: "modifications-previous",
  },
];
